import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  table: {
    minWidth: '100%'
  },
  tableContainer: {
    backgroundColor: 'transparent',
    width: '100%',
    marginTop: 5,
    marginBottom: 50,
    overflowX: 'auto'
  },
  tableCabeceras: {
    textAlign: 'left'
  },
  title: {
    border: 10,
    marginTop: 20
  }
}));
